/**
 * Return unix time used by the API from date.
 */
export function toUnixTime(date) {
  return date.getTime();
}
